import { Button, Card, Divider, Form, Input, InputNumber, List, message, Row, Select, Space, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import {
	MinusCircleOutlined,
	PlusOutlined,
} from "@ant-design/icons";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref, update } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import { Checkbox } from "evergreen-ui";
import { MDBIcon } from "mdbreact";
import FireFetch from "../../Firebase/FireFetch";
import ReactDragListView from "react-drag-listview";
import { useAuth } from "../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";

const IconText = ({ icon, text }) => (
	<Space>
		{React.createElement(icon)}
		{text}
	</Space>
);
const { TextArea } = Input;
var db = getDatabase(Firebase);
const SurveyQuestions = (props) => {
	const { canAccessModule } = useAuth();
	const canUpdateSurvey = canAccessModule("SURVEYS", "update");
	const [questions, loading] = useListVals(ref(db, `talmidsdb/surveys/${props.surveyID}/questions`));
	const [questionArray, setQuestionArray] = useState([]);
	const [fieldArray, setFieldArray] = useState([]);
	const [currentID, setCurrentID] = useState(null);
	const [editID, setEditID] = useState(null);

	useEffect(() => {
		if (questions) {
			var tempArray = [...questions];
			var fields = [];
			tempArray.map((item) => {
				item.choiceOptions && Object.keys(item.choiceOptions).map((key, index) => {
					fields.push(
						{
							"name": [item.questionID + "-" + index],
							"value": item.choiceOptions[key]
						}
					)
				})
				Object.entries(item).map(([key, value]) => {
					fields.push(
						{
							"name": [item.questionID + "-" + key],
							"value": value
						}
					)
				});
			});
			setFieldArray([...fields]);
			setQuestionArray([
				...tempArray.sort((a, b) => Number(a.questionIndex ?? 0) - Number(b.questionIndex ?? 0)),
			]);
		}
	}, [props.surveyID, questions]);

	const handleAnswerType = (option, id) => {
		var question = questionArray.find(x => x.questionID === id);
		question.answerType = option;
		var tArray = questionArray;
		tArray[tArray.findIndex(x => x.questionID === id)] = question;
		setQuestionArray([...tArray]);
	}

	const onDragEnd = (fromIndex, toIndex) => {
		if (!canUpdateSurvey) {
			message.error("You do not have permission to reorder survey questions.");
			return;
		}

		if (toIndex < 0) return; // Ignores if outside designated area
		const items = [...questionArray];
		console.log(items);
		const item = items.splice(fromIndex, 1)[0];
		items.splice(toIndex, 0, item);

		items.map((item, index) => {
			item.questionIndex = index;
		});
		setQuestionArray([...items]);
		console.log(items);
		items.map((item) => {
			update(ref(db, `talmidsdb/surveys/${props.surveyID}/questions/${item.questionID}`), item)
		});
	};

	const editQuestion = (values) => {
		if (!canUpdateSurvey) {
			message.error("You do not have permission to edit survey questions.");
			return;
		}

		var question = questionArray.find(x => x.questionID === editID);
		var newObject = {};
		if (String(values[question.questionID + "-answerType"] || "").includes("Multiple Choice")) {
			var array = [];
			(question.choiceOptions || []).map((x, index) => {
				array.push(values[question.questionID + "-" + index]);
				delete values[question.questionID + "-" + index];
			});
			question.choiceOptions = array;
			newObject.choiceOptions = array;
		}

		Object.entries(values).forEach(([key, value]) => {
			var newKey = key.split("-")[1];
			newObject[newKey] = value;
		});

		update(ref(db, `talmidsdb/surveys/${props.surveyID}/questions/${question.questionID}`), newObject)
			.then((result) => {
				FireFetch.addLog("surveys", question.questionID, "Edit");
				message.success("question edited successfully");

			})
			.catch((error) => {
				message.error(`Unable to edit question. An error occurred : ${error.message}`);
			})
	}

	return (
		<>
			<ReactDragListView
				nodeSelector=".ant-list-item.draggable-item"
				onDragEnd={onDragEnd}
			>
				<List
					itemLayout="vertical"
					loading={loading}
					dataSource={questionArray}
					renderItem={(field, index) => (

						<List.Item
							className="draggable-item"
							key={field.questionID}
							extra={
								<div>
									{canUpdateSurvey ? (
										currentID !== field.questionID ?
											<Button
												type="primary"
												size="large"
												width={200}
												htmlType="submit"
												form={"Form=" + field.questionID}
												onClick={() => {
													setCurrentID(field.questionID);
													setEditID(field.questionID);
												}}
											>
												<MDBIcon icon="pen" />
											</Button>

											:
											<Button
												type="primary"
												size="large"
												width={200}
												onClick={() => {
													setCurrentID("field.questionID");

												}}
											>
												<MDBIcon icon="check" />
											</Button>
									) : null}
								</div>
							}

							actions={[
								<>

									{
											canUpdateSurvey && String(field.answerType || "").includes("Multiple Choice") ?
											<Button onClick={() => {
												setCurrentID(field.questionID);
												setEditID(field.questionID);
												var question = questionArray.find(x => x.questionID === field.questionID);
												question.choiceOptions ? question.choiceOptions.push("") : question.choiceOptions = [""];
												var tArray = questionArray;
												tArray[tArray.findIndex(x => x.questionID === field.questionID)] = question;
												setQuestionArray([...tArray]);
											}}>
												<IconText icon={PlusOutlined} text="Add Option" key="list-vertical-star-o" />
											</Button> :
											null
									}

								</>

							]}
						>

							<div style={{ cursor: "pointer" }}>
								<Divider orientation="left" className="font-weight-bolder">{"Question " + (index + 1)}</Divider>
								<Form
									layout="vertical"
									id={"Form=" + field.questionID}
									onFinish={editQuestion}
									fields={fieldArray}
								>
									<Form.Item label={"Question " + (index + 1)}
										name={field.questionID + "-question"}
										rules={[{ required: true }]}
									>
										<TextArea disabled={currentID !== field.questionID} placeholder={"enter question"} id={field.questionID} />
									</Form.Item>
									<Form.Item label="Answer Type"
										name={field.questionID + "-answerType"}
										rules={[{ required: true }]}
									>
										<Select placeholder="Select answerType"
											showSearch
											optionFilterProp="children"
											filterOption={filterSelectOption}
											disabled={currentID !== field.questionID}
											filterSort={sortSelectOptions} onChange={(option) => { handleAnswerType(option, field.questionID) }}>
											{["Yes/No", "Multiple Choice",
												"Linear Scale", "Long answer", "Short answer"]
												.map((item, index) => (
													<Select.Option key={index} value={item}>{item}</Select.Option>
												))}

										</Select>
									</Form.Item>

									{field.answerType === "Yes/No" ?

										<>
											<Form.Item name={field.questionID + "-maybeOption"} valuePropName="checked">
												<Checkbox
													disabled={currentID !== field.questionID}
													label={<p className="font-Nunito">Add Maybe Option</p>}
												/>
											</Form.Item>
										</>
										:
										null
									}

									{field.answerType === "Linear Scale" ?
										<>
											<p>Select scale minimum and maximum</p>
											<Row>
												<Form.Item name={field.questionID + "-min"}>
													<InputNumber disabled={currentID !== field.questionID} min={1} max={10}
														className="mr-2" placeholder="min" />
												</Form.Item>
												<Form.Item name={field.questionID + "-max"}>
													<InputNumber
														disabled={currentID !== field.questionID}
														min={1} max={10} className="mr-2" placeholder="max" />
												</Form.Item>
											</Row>
											<Form.Item label="Minimum Label"
												name={field.questionID + "-minLabel"}>
												<Input
													disabled={currentID !== field.questionID}
													placeholder="minimum label" />
											</Form.Item>
											<Form.Item label="Maximum Label"
												name={field.questionID + "-maxLabel"}>
												<Input
													disabled={currentID !== field.questionID}
													placeholder="maximum label" />
											</Form.Item>

										</>
										:
										null
									}

									{String(field.answerType || "").includes("Multiple Choice") ?

										<>
											{field.choiceOptions && (Object.keys(field.choiceOptions)).map((key, index) => (
												<>
													<Form.Item
														required={false}
													//key={field.questionID+"-"+key}
													>
														<Form.Item
															name={field.questionID + "-" + index}
															validateTrigger={['onChange', 'onBlur']}
															rules={[
																{
																	required: true,
																	whitespace: true,
																	message: "Please input option text",
																},
															]}
															noStyle
														>
															<Input
																placeholder="enter option text"
																disabled={currentID !== field.questionID}
																id={field.questionID + "-" + index}
																style={{
																	width: '94%',
																}}
															/>
														</Form.Item>
														{canUpdateSurvey && questionArray.length > 0 ? (
															<Tooltip title="Remove option">
																<Button type="danger"
																	shape="circle"
																	icon={<MinusCircleOutlined />}
																	className="dynamic-delete-button mx-2"
																	onClick={() => {
																		setCurrentID(field.questionID);
																		setEditID(field.questionID);
																		var question = questionArray.find(x => x.questionID === field.questionID);
																		question.choiceOptions.splice(index, 1);
																		var tArray = questionArray;
																		tArray[tArray.findIndex(x => x.questionID === field.questionID)] = question;
																		setQuestionArray([...tArray]);
																		update(ref(db, `talmidsdb/surveys/${props.surveyID}/questions/${question.questionID}`), question)
																	}} />
															</Tooltip>


														) : null}
													</Form.Item>
												</>
											))}
										</>

										:
										null
									}

								</Form>
							</div>


						</List.Item>



					)}
				/>
			</ReactDragListView>



		</>
	)
}

export default SurveyQuestions;
